'use client'

// SignalBar — the marks strip, opened with R while walking (or closed with R
// again / after sending). Number keys 1-5 send from the keyboard (handled in
// FirstPersonController so pointer lock stays); the buttons work for anyone
// mousing instead.
//
// Sits in its own slot above the status pill (lib/ui/layout). It used to be
// anchored bottom-20 while the pill sat at bottom-5, so the moment both were
// up the strip landed right on the pill.

import useGameStore from '../../stores/gameStore'
import { SignalGlyph } from './SignalGlyphs'
import { sendPlayerSignal, SIGNAL_MARKS } from '../../lib/signalSend'
import { ui, kawaii } from '../../lib/ui/theme'
import { hud } from '../../lib/ui/layout'

export function SignalBar() {
  const open = useGameStore((s) => s.signalBarOpen)
  const droneActive = useGameStore((s) => s.droneActive)
  if (!open || droneActive) return null

  const send = (kind) => {
    const pos = useGameStore.getState().playerPosGetter?.()
    if (pos) sendPlayerSignal(kind, pos)
  }

  return (
    <div
      className="fixed left-1/2 -translate-x-1/2 z-40 pointer-events-auto"
      style={{ bottom: hud.signalBottom }}
    >
      <div
        className="flex items-center gap-1 px-2.5 py-1.5"
        style={{
          background: kawaii.cream,
          border: kawaii.outline,
          borderRadius: kawaii.radiusPill,
          boxShadow: kawaii.dropSm,
        }}
      >
        <span
          className="self-center px-1.5"
          style={{ color: kawaii.inkSoft, fontFamily: ui.font, fontSize: 11, fontWeight: 700 }}
        >
          say hello
        </span>
        {SIGNAL_MARKS.map((kind, i) => (
          <button
            key={kind}
            type="button"
            onClick={() => send(kind)}
            className="flex flex-col items-center gap-0.5 px-1.5 py-1"
            style={{ borderRadius: 12, background: 'transparent', border: 'none', cursor: 'pointer' }}
            aria-label={`send ${kind}`}
            onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(47,38,80,0.09)' }}
            onMouseLeave={(e) => { e.currentTarget.style.background = 'transparent' }}
          >
            <SignalGlyph kind={kind} size={22} />
            <span style={{ color: kawaii.inkSoft, fontFamily: ui.font, fontSize: 9, fontWeight: 700 }}>
              {i + 1}
            </span>
          </button>
        ))}
      </div>
    </div>
  )
}

export default SignalBar
